<template>
  <div class="esPrimario">
    <input ref="radioEsPrimario" class="radio pointer" type="radio" @change="select" name="radioPrimario"
           :id="'radio-'+index" :checked="checked(index)">
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    props: ["index"],
    name: "EsPrimario",
    computed: {
      ...mapGetters({
        vehiculosCompatibles: "producto/vehiculosCompatibles"
      })
    },
    methods: {
      select() {
        this.$store.commit("producto/RESET_ALL_CHECKED")
        const radios = document.querySelectorAll(".radio")
        const radio_checked = Array.from(radios).find(item => item.checked === true)
        if (radio_checked !== undefined)
          this.$store.commit("producto/SET_KEY_VEHICULO_COMPATIBLE", {
            key: "esPrimario",
            data: true,
            index: this.index
          })
      },
      checked(index) {
        const check = this.$store.getters["producto/vehiculosCompatibles"][index].esPrimario
        return check !== false;
      }
    }
  }
</script>

<style scoped>

</style>
